export default __webpack_public_path__ + "static/SuburbanRetrofits-5109cfbf2b2efdc36f9f4ab76336c043.jpg";